import { AlbumArt } from './AlbumArt';
import { PlusIcon, CheckIcon } from './icons';
import { formatMs } from '../../utils/formatMs';

export function SongItem({ song, staged, canAdd, onAdd }) {
  let label = `Agregar ${song.name} a tu selección`;
  let btnClass = 'bg-lounge-raised text-lounge-brass hover:bg-lounge-brass hover:text-lounge-base';
  if (staged) {
    label = `${song.name} ya está en tu selección`;
    btnClass = 'bg-lounge-brass text-lounge-base';
  } else if (!canAdd) {
    label = 'Sin créditos para agregar más canciones';
    btnClass = 'bg-lounge-raised/50 text-lounge-smoke cursor-not-allowed';
  }

  return (
    <div className="flex items-center gap-3 rounded-md bg-lounge-card/60 p-2 transition-colors hover:bg-lounge-card">
      <AlbumArt image={song.image} alt="" className="w-14" />
      <div className="min-w-0 flex-1">
        <p className="truncate font-inter text-[15px] font-medium text-lounge-text">{song.name}</p>
        <p className="flex min-w-0 gap-1.5 font-inter text-sm text-lounge-stone">
          <span className="truncate">{song.artist}</span>
          {song.durationMs > 0 && (
            <span className="shrink-0 font-mono text-xs leading-5 tabular-nums text-lounge-stone">
              · {formatMs(song.durationMs)}
            </span>
          )}
        </p>
      </div>
      <button
        onClick={() => onAdd(song)}
        disabled={staged || !canAdd}
        aria-label={label}
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-all
                    duration-200 active:scale-90 ${btnClass}`}
      >
        {staged ? <CheckIcon className="h-5 w-5" /> : <PlusIcon className="h-5 w-5" />}
      </button>
    </div>
  );
}
